module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;
  return _h('transition', {
    attrs: {
      "name": "slide-fade"
    }
  }, [_h('div', {
    staticClass: "page work"
  }, [_h('ul', {
    staticClass: "project-list"
  }, [_vm._l((_vm.projects), function(project) {
    return _h('li', {
      staticClass: "project"
    }, [(project.thumbnail && project.thumbnail != '') ? _h('img', {
      staticClass: "project__thumbnail",
      attrs: {
        "src": _vm.imagePath(project.thumbnail)
      }
    }) : _vm._e(), " ", _h('h2', {
      staticClass: "project__title"
    }, [_vm._s(project.title)]), " ", _h('p', {
      staticClass: "project__description"
    }, [_vm._s(project.description)]), " ", (project.link && project.link != '') ? _h('a', {
      staticClass: "project__link",
      attrs: {
        "href": project.link
      }
    }, ["View\n\t\t\t\t\tthe site"]) : _vm._e()])
  })])])])
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler.js?id=data-v-61ccf6a6!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/Work.vue
// module id = 24
// module chunks = 1